import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import ScrollToTop from "./ScrollToTop";

import LandingPage from "./components/landing_page/LandingPage";

import Aldeia from "./components/aldeia/Aldeia";

import NoticiasEventos from "./components/noticias_e_eventos/NoticiasEventos";
import Noticia from "./components/noticias_e_eventos/noticia_evento_get/NoticiaEvento";

import PontosInteresse from "./components/pontos_interesse/PontosInteresse";
import PontoInteresse from "./components/pontos_interesse/ponto_interesse_get/PontoInteresse";

import AquiPerto from "./components/aqui_perto/AquiPerto";
import AquiPertoDetalhes from "./components/aqui_perto/aqui_perto_get/AquiPerto";

import Restaurantes from "./components/restaurantes/Restaurantes";
import Restaurante from "./components/restaurantes/restaurantes_get/Restaurante";

import Lojas from "./components/lojas/Lojas";
import Loja from "./components/lojas/lojas_get/Loja";

import Alojamentos from "./components/alojamento/Alojamentos";
import Alojamento from "./components/alojamento/alojamento_get/Alojamento";

import Avisos from "./components/avisos/Avisos";
import Aviso from "./components/avisos/aviso_get/Aviso";

import Executivo from './components/avisos/Executivo';

import Contactos from './components/contactos/Contactos';

import Essencias from './components/essencia/Essencias';
import Essencia from "./components/essencia/essencia_get/Essencia";

import Login  from './components/auth/Login';

import Termos from "./components/Termos";

import NotFound from "./components/NotFound";

import ProtectedRoutes from './routes/ProtectedRoutes';

const Routes = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Route exact path="/" component={LandingPage} />

        <Route path="/sabugueiro" component={Aldeia} />

        <Route path="/noticias_e_eventos/:identifier" component={Noticia} />
        <Route path="/noticias_e_eventos" component={NoticiasEventos} />

        <Route path="/pontos_interesse/:identifier" component={PontoInteresse} />
        <Route path="/pontos_interesse" component={PontosInteresse} />

        <Route path="/aqui_perto/:identifier" component={AquiPertoDetalhes} />
        <Route path="/aqui_perto" component={AquiPerto} />

        <Route path="/restaurantes/:identifier" component={Restaurante} />
        <Route path="/restaurantes" component={Restaurantes} />

        <Route path="/lojas/:identifier" component={Loja} />
        <Route path="/lojas" component={Lojas} />

        <Route path="/alojamentos/:identifier" component={Alojamento} />
        <Route path="/alojamentos" component={Alojamentos} />

        <Route path="/comunidade/:identifier" component={Aviso} />
        <Route path="/comunidade" component={Avisos} />

        <Route path="/executivo" component={Executivo} />

        <Route path="/contactos" component={Contactos} />

        <Route path="/essencia/:identifier" component={Essencia} />
        <Route path="/essencia" component={Essencias} />

        <Route path="/termos_e_condicoes" component={Termos} />

        <Route path="/not_found" component={NotFound} />

        <Route path="/login" component={Login} />

        <ProtectedRoutes></ProtectedRoutes>

        <Redirect from="/old-match" to="/will-match"/>
        <Route path="/will-match" component={NotFound}/>
        <Route path="*" exact={true} component={NotFound}/>

      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
